<template>
    <div class="custom-select" v-for="filter in filters" :key="filter.Id">
        <input
            type="radio"
            v-model="vmChecked"
            class="radio"
            :id="`rl-filter-${filter.Id}`"
            :value="`${filter.Id}`"
            :checked="vmChecked === filter.Id"
            @change="onChange(alias, filter)" />
        <label class="checkbox-label" :for="`rl-filter-${filter.Id}`">{{ filter.Name }}</label>
    </div>
</template>

<script setup lang="ts">
// Vue
import { ref, onMounted, watch } from 'vue';

// Pinia
import { storeToRefs } from 'pinia';

// Model
import { ICheckboxType } from '../../apps/ridingschool/model/ridingschool.models';

// Store
import { useRidingschoolStore } from '../../apps/ridingschool/store/ridingschool.store';

// Composable
import { useSearchParamUpdate } from '../../composables/useSearchParamUpdate';

const props = defineProps<{
    alias: string;
    filters: ICheckboxType[];
}>();

const ridingschoolStore = useRidingschoolStore();
const { resetComponentState } = storeToRefs(ridingschoolStore);

const vmChecked = ref();

function onChange(alias: string, filter: ICheckboxType) {
    useSearchParamUpdate(ridingschoolStore, 'remove', 'page', '');
    useSearchParamUpdate(ridingschoolStore, 'update', alias, filter.Id);
}

function handleCheckedState() {
    if (ridingschoolStore.searchParams?.get(props.alias) !== null) {
        vmChecked.value = ridingschoolStore.searchParams?.get(props.alias);
    } else {
        vmChecked.value = 1;
    }
}

watch(resetComponentState, () => {
    handleCheckedState();
});

onMounted(() => {
    handleCheckedState();
});
</script>
